import React, { useEffect, useRef, useState } from 'react'

export const RecorderTest = () => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const animationRef = useRef<number | null>(null)

  const [micError, setMicError] = useState<string | null>(null)
  const [micAvailable, setMicAvailable] = useState(false)

  useEffect(() => {
    let audioContext: AudioContext
    let analyser: AnalyserNode
    let dataArray: Uint8Array
    let source: MediaStreamAudioSourceNode

    const init = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
        })
        setMicAvailable(true)

        audioContext = new AudioContext()
        analyser = audioContext.createAnalyser()
        source = audioContext.createMediaStreamSource(stream)

        analyser.fftSize = 128
        dataArray = new Uint8Array(analyser.frequencyBinCount)
        source.connect(analyser)

        const canvas = canvasRef.current
        const ctx = canvas?.getContext('2d')
        if (!ctx || !canvas) return

        const draw = () => {
          animationRef.current = requestAnimationFrame(draw)

          analyser.getByteTimeDomainData(dataArray)
          ctx.clearRect(0, 0, canvas.width, canvas.height)

          const barWidth = 4
          const barGap = 2
          const totalBars = Math.floor(canvas.width / (barWidth + barGap))

          for (let i = 0; i < totalBars; i++) {
            const value = dataArray[i]
            const percent = value / 255
            const barHeight = percent * canvas.height

            // 평균값을 기준으로 움직임 있는지 판단
            const isSound = Math.abs(value - 128) > 5

            ctx.fillStyle = isSound ? '#ef4444' : '#e5e7eb' // 빨강 / 회색 (Tailwind 기준)
            ctx.fillRect(
              i * (barWidth + barGap),
              canvas.height - barHeight,
              barWidth,
              barHeight
            )
          }
        }

        draw()
      } catch (err: any) {
        console.error('🎤 마이크 접근 실패:', err)
        if (err.name === 'NotAllowedError') {
          setMicError('마이크 사용 권한이 허용되지 않았습니다.')
        } else if (err.name === 'NotFoundError') {
          setMicError('마이크 장치를 찾을 수 없습니다.')
        } else {
          setMicError('마이크를 사용할 수 없습니다.')
        }
      }
    }

    init()

    return () => {
      if (animationRef.current) cancelAnimationFrame(animationRef.current)
      audioContext?.close()
    }
  }, [])

  return (
    <div className="flex flex-col items-center gap-4 p-4">
      <div className="text-[64px]">🎙️</div>

      {micError ? (
        <p className="text-red-500 font-semibold">{micError}</p>
      ) : micAvailable ? (
        <>
          <p className="text-lg font-semibold">마이크가 잘 작동합니다.</p>
          <canvas ref={canvasRef} className="w-[260px] h-[100px]  rounded" />
        </>
      ) : (
        <p className="text-gray-500">마이크 상태 확인 중...</p>
      )}
    </div>
  )
}
